import React from "react";
import { scroller } from "react-scroll";

import {
  ABOUT_US_GLOBAL_LINK,
  BECOME_A_BATMAID_LINK,
  HELP_LINK_BATMAID,
} from "@config/links";
import { NAVBAR } from "@config/testIds/navbar";
import { PATHS, ROUTES } from "@config/app.routing";

import { AVAILABLE_LANGS } from "@typings/globals";
import { ANCHOR_QURIES, ANCHOR_IDS } from "@typings/anchorIds";

import { info } from "@components/Navigation/NavBar";

import { buildUrl } from "@services/BuildUrl";
import { createHref } from "@services/CreateHref";

import { TranslateFunction } from "@hooks/useTranslate";

import { Link } from "../../typings/link";

export const getLinks = (
  language: AVAILABLE_LANGS,
  translate: TranslateFunction,
): Link[] => [
  {
    label: translate("batmaid_pwa_navigation.our_services"),
    href: buildUrl(createHref(language, "/"))
      .addQuery(ANCHOR_QURIES.SCROLL_TO, ANCHOR_IDS.OUR_SERVICES)
      .done(),
    testId: NAVBAR.OUR_SERVICES,
    eventId: "our-services-header",
  },
  {
    label: translate("batmaid_pwa_navigation.about_us"),
    href: createHref(language, ABOUT_US_GLOBAL_LINK),
    testId: NAVBAR.ABOUT_US,
    eventId: "about-us-header",
  },
  {
    label: translate("batmaid_pwa_navigation.help"),
    href: createHref(language, HELP_LINK_BATMAID),
    testId: NAVBAR.HELP,
    eventId: "help-header",
  },
  {
    label: translate("batmaid_pwa_navigation.career"),
    href: createHref(language, BECOME_A_BATMAID_LINK),
    testId: NAVBAR.CAREER,
    eventId: "become-batmaid-header",
    hiddenFor: "client",
  },
  {
    label: translate("batmaid_pwa_navigation.gift_cards"),
    href: `/${language}${PATHS.CLIENT_APP}#${ROUTES.GIFT_CARDS}`,
    testId: NAVBAR.GIFT_CARDS,
    eventId: "gift-cards-header",
    hiddenFor: "agent",
    visibleForFeature: "gift_cards",
  },
];

/**
 * @returns `true` if the link is not redirecting to another page
 */
export const scrollToHandler = (
  event: React.MouseEvent<HTMLAnchorElement>,
): boolean => {
  const $target = event.currentTarget as HTMLAnchorElement;
  const href = $target.getAttribute("href")!;
  const { pathname } = window.location;
  const [hrefPathname, params] = href.split("?");
  const hrefParams = new URLSearchParams(params);

  if (hrefPathname !== pathname || !hrefParams.get(ANCHOR_QURIES.SCROLL_TO)) {
    return false;
  }

  event.preventDefault();

  scroller.scrollTo(hrefParams.get(ANCHOR_QURIES.SCROLL_TO)!, {
    smooth: true,
    offset: -info.scrollOffset,
  });
  return true;
};
